import { SharedModule } from '../../components/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SECURE_ROUTES } from './secure.routes';
import { ServicesModule } from 'src/app/services/services.module';
import { SecureComponent } from './secure.component';
import { PipesModule } from '../../pipes/pipes.module';
import { DirectivesModule } from '../../directives/directives.module';
import { LoginSubjectObligedComponent } from '../public/login-subject-obliged/login-subject-obliged.component';
import { NguCarouselModule } from '@ngu/carousel';


@NgModule({
  imports: [
    SECURE_ROUTES, 
    CommonModule, 
    ServicesModule, 
    SharedModule, 
    PipesModule, 
    DirectivesModule, 
    NguCarouselModule,
  ],
  declarations: [SecureComponent, LoginSubjectObligedComponent],
})
export class SecureModule {}
